'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

var _commonFunctions = require('../../helpers/commonFunctions');

var _dateFunctions = require('../../helpers/dateFunctions');

var _dateFunctions2 = _interopRequireDefault(_dateFunctions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Transforms the data in a Redux Form component to the format required by the API.
 * The data should be in the form given by this.props.values in the connected Redux Form
 *   component.
 * @param {Object} formValues - The form values to transform.
 * @param {Object} trackingCode - The referral code.
 * @returns {Object} - The transformed values.
 */

exports.default = function (formConfig, formValues, trackingCode) {
  var applicant = formValues.applicant,
      _formValues$applicati = formValues.application,
      additional_data = _formValues$applicati.additional_data,
      effective_date = _formValues$applicati.effective_date,
      expiry_date = _formValues$applicati.expiry_date;


  var data = _extends({}, (0, _commonFunctions.transformApplication)(formValues, trackingCode), {
    expiry_date: (0, _moment2.default)(effective_date).add(364 + _dateFunctions2.default.getLeapYearDay(effective_date, 364), 'days').format('YYYY-MM-DD')
  });

  if (formValues.application.additional_data.school === 'other') {
    applicant.forEach(function (appl) {
      appl.additional_data.school = 'other';
    });
  }

  return data;
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/student-accident/application.js
// module id = 1757
// module chunks = 0